{"id":"ProductDetail.Info.Packaging","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Packaging","options":"options:*"}]}}}